import React, {Component} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {makeUiMainProjectList, validateEmailsString} from "../prodect/ProsCommonUi";
import AccordionDropdown from "../components/AccordionDropdown";
import BasicButton, {ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";

import {
    prosNotificationShow, prosPopupClose, prosPopupCloseAll, prosPopupOpenDynamic, prosPopupRender,
} from "../prodect/ProsPopup";
import {
    ATTR_AWS_PROJECT_ID, ATTR_CUSTOMER_GROUP,
    ATTR_MAIN_PROJECT_NAME,
    ATTR_OBJ_ID, ATTR_TEXT, CUSTOMER_NAME_MIN_LEN, getCustomerSettings, hasPermissionTo,
    PROJECT_NAME_MAX_LEN,
    PROJECT_NAME_MIN_LEN, prosLog, prosLogDt, prosLogErr,
    saveCustomerSettings, STR_NO_VALUE, STR_YES, validateCampaignCode,
} from "../prodect/ProsConnect";

import {setHelpContext} from "../prodect/HelpManager";
import LoadingAnimation from "../components/LoadingAnimation";
import FileUploader from "../components/FileUploader";
import DropdownMenu from "../components/DropdownMenu";
import TextInput from "../components/TextInput";
import TabsNavigation from "../components/TabsNavigation";
import BasicModal, {BasicModalDismiss} from "../components/BasicModal";
import UiImage from "../components/UiImage";

export const ATTR_CUSTOMER_BILL_REFERENCE = 'bill_ref_id'
export const ATTR_TEXT_TO_BILL = "text_to_bill"
const PROJECT_TEXT_TO_BILL = 'projectTextToBill'

const SETTINGS_DATA_VERSION = 1


// UI has three modes
//  CREATE_PRJ_PHASES_CUSTOMER_ADMIN - editing all customer data and create a new project
//  CREATE_PRJ_PHASES_MAIN_PROJ_EDIT  - edit customer and project billing - main project ... menu
//  CREATE_PRJ_PHASES_CUSTOMER_EDIT  - edit customer data / settings
//  CREATE_PRJ_PHASES - create a new project but user has no rights to edit customer or its' billing data
//
const CREATE_PRJ_PHASES_CUSTOMER_ADMIN = ['phaseCustomer', 'phaseCalculator', 'phaseBilling',
    'phaseCreateProjectBilling', 'phaseSummary']

const CREATE_PRJ_PHASES_MAIN_PROJ_EDIT = ['phaseCustomer', 'phaseBilling', 'phaseEditProjectBilling']
const CREATE_PRJ_PHASES = ['phaseCustomer', 'phaseCalculator', 'phaseCreateProjectBilling', 'phaseSummary']

// todo - temporal solution to configure logo for customer - hide "phaseCustomerOther" so far
//const CREATE_PRJ_PHASES_CUSTOMER_EDIT = ['phaseCustomer', 'phaseBilling', 'phaseCustomerOther']
const CREATE_PRJ_PHASES_CUSTOMER_EDIT = ['phaseCustomer', 'phaseBilling']

// Page tab titles
const CREATE_PRJ_PHASE_FOR_UI = {
    'phaseCustomer': 'Yhteystiedot',
    'phaseCalculator': 'Hintalaskuri',
    'phaseBilling': 'Laskutusosoite',
    'phaseSummary': 'Tilauksen vahvistus',
    'phaseCreateProjectBilling': 'Projektin nimi ja laskutus',
    'phaseEditProjectBilling': 'Projektin laskutus',
    'phaseCustomerOther': 'Muita asetuksia'
}

const PHASE_HELP = {
    'phaseCustomer': 'mainProj-customer',
    'phaseCalculator': 'mainProj-priceCalc',
    'phaseBilling': 'mainProj-billing',
    'phaseSummary': 'mainProj-confirm',
    'phaseCreateProjectBilling': 'mainProj-project',
    'phaseEditProjectBilling': 'mainProj-project',
    'phaseCustomerOther': 'mainProj-customer'
}

/**
 *  Note - state 'settings' is stored to server when starting to continue ordering project
 *  Use this.settings.x to refer to a saved setting and this.setSettings({x: value}) to update.
 */

// Phases to prompt info from user - ref Excel 'Projektin tilaaminen' for spec - order new project
//  1. 'phaseCustomer'              Customer name info
//  2. 'phaseBilling'               Billing address etc - not shown when user not a customer "head admin"
//  3. 'phaseCreateProjectBilling'  Project billing info
//  4. 'phaseCalculator'            Calculate cost taking into account customer
//  5. 'phaseSummary'               Review summary and place an order

// Phases to prompt info from user - edit customer & project billing data
//  1. 'phaseCustomer'              Customer name info
//  2. 'phaseBilling'               Billing address etc - service acceptance
//  3. 'phaseEditProjectBilling'    Project billing info

// Phases for main settings / customer
//  1. 'phaseCustomer'              Customer name info
//  2. 'phaseBilling'               Billing address etc - service acceptance
//  3. 'phaseCustomerOther'         Other settings like logo


export default class CreateMainProject extends Component {
    constructor(props) {
        super(props);

        // Other data is generated by UI and saved to server
        // attributes starting by server are provided by server
        this.settings = {
            settingsVersion: SETTINGS_DATA_VERSION,
            customerGroup: STR_NO_VALUE,
            proj_name: '',
            customerName: '',
            serverCustomers: undefined,             // [ { customerGroup, name, ... } ]
        }
        this.state = {
            isLoading: true,
            hasSettingsFromServer: false,
            customerProjectsForSettings: [],
            customerProjectsForPermissions: [],
            mainProjectList: undefined,
            searchInput: '',
            searchInputUser: '',
            selectedMainProjectName: '',            // main project to copy settings (+ opt more)
            selectedUserProjectName: '',            // main project to copy users
            phase: CREATE_PRJ_PHASES[0],
            settings: undefined,
            customers: [],
            copyUserPermissionsProjectName: '',
            isMasterAdmin: false,
            miscSettings: undefined,
            logoFileName: undefined,
            orderOngoing: false,
            orderCompleted: false,
            mainProjectCampaignCode: '',
            mainProjectCampaignCodeIsValid: false,
            mainProjectCampaignCodeError: '',
        }
        this.refProjects = undefined
    }

    async componentDidMount() {
        prosLog("CreateMainProject props:", this.props)
        await this.loadSettings()
        // Clear project name to ensure that user checks name for a new project
        if (this.props.isMakingNewProject) {
            this.setSettings({proj_name: '', projectBillingRef: '', projectTextToBill: ''})
        }
        setHelpContext('mainProj-customer')
    }

    componentWillUnmount() {
        prosPopupCloseAll()
        BasicModalDismiss()
    }

    async componentDidUpdate(prevProps) {
        // Reload if user selected another main project from ... menu or
        // changed from editing maninproject billing to add a new main project
        if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
            prosLog("CreateMainProject - changed props:", this.props)
            await this.loadSettings()
            if (this.props.isMakingNewProject) {
                this.setSettings({proj_name: '', projectBillingRef: '', projectTextToBill: ''})
            }
        }
        if (this.state.helpPage !== PHASE_HELP[this.state.phase]) {
            this.setState({helpPage: PHASE_HELP[this.state.phase]})
            setHelpContext(PHASE_HELP[this.state.phase])
        }
    }

    makeCustomerIdList(refProjects) {
        return refProjects
            .filter(mp => mp.referenceToCreateNew)      // has admin right when have a ref project
            .map(mp => mp.customerGroup)                // list of customer ID's
            .filter((x, i, a) => a.indexOf(x) === i)    // make list unique
    }

    selectCustomer(customerGroup, clearIfNewCustomer) {
        if (!customerGroup || customerGroup !== this.settings.customerGroup) {
            // unselect main project's for ref & permissions when change customer
            this.setState({
                selectedMainProjectName: '',
                selectedUserProjectName: '',
            })
        }
        if (!customerGroup || customerGroup === STR_NO_VALUE) {
            this.setSettings({
                customerGroup: STR_NO_VALUE,
                customerName: clearIfNewCustomer ? '' : this.settings.customerName
            })
        } else {
            let customer = this.settings.serverCustomers
                .find(customer => customer[ATTR_OBJ_ID] === customerGroup)
            this.setSettings({
                customerGroup: customerGroup,
                customerName: customer ? customer.text : '?',
            })
        }
        if (clearIfNewCustomer) {
            this.setSettings({
                projectBillingRef: '',
                projectTextToBill: ''
            })
        }
        this.setCurrentCustomerInfo(customerGroup, 'B', clearIfNewCustomer)
        let customerFields = this.setCurrentCustomerInfo(customerGroup, 'C', clearIfNewCustomer)
        this.setIsEMailInMasterAdmins(customerFields)
        this.clearCostEstimates()
    }

    async saveMiscCustomerSettings() {
        if (!this.props.isEditCustomerMode) {
            return
        }
        if (!this.state.miscSettings) {
            prosLogErr("Missing customer misc settings")
            return
        }
        if (this.state.logoFileName !== this.state.miscSettings.logoFileName) {
            let miscSettings = {logoFileName: this.state.logoFileName}
            await saveCustomerSettings(this.props.customerAndProject.customerGroup, miscSettings)
        }
    }

    async loadMiscCustomerSettings() {
        if (!this.props.isEditCustomerMode) {
            return
        }
        let customerSettings = await getCustomerSettings(this.props.customerAndProject.customerGroup)
        this.setState({
            miscSettings: customerSettings,
            logoFileName: customerSettings.logoFileName
        })
    }

    async loadSettings(continueAfterSave) {
        this.setState({ isLoading: true})
        if (!continueAfterSave) {
            if (this.props.customerAndProject?.editMainProject) {
                // when opened to edit main project name and billing preselect project data TAB
                this.setState({ phase: 'phaseEditProjectBilling'})
            } else {
                this.setState({ phase: CREATE_PRJ_PHASES[0]})
            }
        }
        let mainProjectList = await makeUiMainProjectList('all')
        this.refProjects = mainProjectList
            .filter(mp => mp.customerGroup !== 'MyProdect')
        let customerIds = this.makeCustomerIdList(this.refProjects)
        let response = await prosConnect.getCreateProjectSettings(this.settings, customerIds, this.props.customerAndProject)
        if (response && response.result && response.result === 'OK') {
            if (response.settings && response.settings.settingsVersion === SETTINGS_DATA_VERSION) {
                this.setSettings(response.settings)
                this.setState({
                    hasSettingsFromServer: true,
                    uiFieldsCustomerInfo: this.getCustomerInfoFromTemplate('C'),
                    uiFieldsBillingInfo: this.getCustomerInfoFromTemplate('B')
                })
                this.selectCustomer(response.settings.customerGroup, false)
            }
        }
        this.setState({
            isLoading: false,
            mainProjectList: mainProjectList
        })
        await this.loadMiscCustomerSettings()
        if (this.props.isMakingNewProject) {
            if (this.isProjectNameInUse()) {
                this.setSettings({proj_name : ''})
            }
            // make new project - when have an active project select customer as default
            let activeProject = prosConnect.getActiveProject()
            if (hasPermissionTo("orderMainProject")) {
                this.selectCustomer(activeProject.getAttr(ATTR_CUSTOMER_GROUP))
            } else if (this.settings.customerGroup === STR_NO_VALUE) {
                // Adding a new project - keep settings as received (prev one) from a server
            } else if (!continueAfterSave) {
                this.selectCustomer(undefined, true)
            }
        } else {
            // Set based on selected customer and main project
            if (this.settings.mainProjectAttrs) {
                this.setSettings({
                    customerGroup: this.props.customerAndProject.customerGroup,
                    proj_name: this.settings.mainProjectAttrs[ATTR_TEXT],
                    projectBillingRef: this.settings.projectBillingRef
                        ? this.settings.projectBillingRef
                        : this.settings.mainProjectAttrs[ATTR_CUSTOMER_BILL_REFERENCE],
                    projectTextToBill: this.settings.projectTextToBill
                        ? this.settings.projectTextToBill
                        : this.settings.mainProjectAttrs[ATTR_TEXT_TO_BILL],
                })
            }
            this.selectCustomer(this.props.customerAndProject.customerGroup)
        }
    }

    /**
     * Make a dynamic UI based on customer info by parsing customer template from server
     * @param displayCategory   'C' | 'B' | 'X', C = customer info, B = billing info, X = exclude
     * @returns [{}]  - uiFields - ref attrs below key..
     */
    getCustomerInfoFromTemplate(displayCategory) {
        let uiFields = []
        //const TEMPLATE_ENG_DESC = 0
        const TEMPLATE_FORMAT = 1
        const TEMPLATE_MANDATORY = 2
        const TEMPLATE_DISP_CATEGORY = 3
        const TEMPLATE_SORT_ORDER = 4
        const TEMPLATE_FIN_DESC = 5

        Object.keys(this.settings.serverCustomerTemplate)
            .filter(key => typeof this.settings.serverCustomerTemplate[key] === 'string')
            .filter(key => this.settings.serverCustomerTemplate[key].split(';').length > TEMPLATE_FIN_DESC)
            .forEach(key => {
                let templateStrs = this.settings.serverCustomerTemplate[key].split(';')
                if (templateStrs[TEMPLATE_DISP_CATEGORY] === displayCategory) {
                    let format = templateStrs[TEMPLATE_FORMAT]
                    if (format !== 'X') {
                        // let engDescr = templateStrs[TEMPLATE_ENG_DESC]
                        let finDesc = templateStrs[TEMPLATE_FIN_DESC]
                        let finPlaceholder = ''
                        let hasPlaceHolderText = finDesc.includes('(') && finDesc.includes(')')
                        if (hasPlaceHolderText) {
                            finDesc = finDesc.split('(')[0]
                            finPlaceholder = templateStrs[TEMPLATE_FIN_DESC]
                                .replace(finDesc, '')
                                .replace('(', '')
                                .replace(')', '')
                        }
                        uiFields.push({
                            key: key,
                            isMandatory: templateStrs[TEMPLATE_MANDATORY] === STR_YES,
                            format: templateStrs[TEMPLATE_FORMAT], // S string, N number, (B boolean)
                            sortOrder: isNaN(templateStrs[TEMPLATE_SORT_ORDER]) ?
                                0 : parseInt(templateStrs[TEMPLATE_SORT_ORDER]),
                            finDesc: finDesc,
                            finPlaceholder: finPlaceholder
                        })
                    }
                }
            })
        return uiFields
    }

    setSettings(changes) {
        Object.keys(changes).forEach(key => this.settings[key] = changes[key])
        let stateUpdate = {settings: {}}
        Object.keys(this.settings).forEach(key => stateUpdate.settings[key] = this.settings[key])
        this.setState(stateUpdate)
    }

    uiPhases() {
        if (!this.props.isMakingNewProject) {
            return this.props.isEditCustomerMode ? CREATE_PRJ_PHASES_CUSTOMER_EDIT : CREATE_PRJ_PHASES_MAIN_PROJ_EDIT
        }
        return this.mayEditCustomerData() ?
            CREATE_PRJ_PHASES_CUSTOMER_ADMIN :
            CREATE_PRJ_PHASES
    }

    setIsEMailInMasterAdmins(customerFields) {
        let ownEmail = prosConnect.getUserEmail(true)
        this.setState({
            isMasterAdmin:
                prosConnect.isSuperUserModeInUse() ||
                !customerFields.admin_emails ||
                customerFields.admin_emails === '' ||
                customerFields.admin_emails.indexOf(ownEmail) >= 0
        })
    }

    mayEditCustomerData() {
        return this.state.isMasterAdmin
    }

    renderBackToProject() {
        if (this.props.isEditCustomerMode) {
            return null
        }
        // Show exit button only for "order new main project"
        return <BasicButton
            btnClass={"2nd"}
            icon={"times"}
            label={"Poistu"}
            action={this.props.switchToReportView}
            shrink={"lg"}
        />
    }

    limitExceededAlert(len, maxLen, note) {
        if (len > maxLen) {
            prosNotificationShow(this, note + ", raja " + maxLen);
            return true
        }
        return false;
    }

    handleSettingsChange(val, attr) {
        let change = {}
        change[attr] = val
        this.setSettings(change)
    }

    handleProjectName(val) {
        if (this.limitExceededAlert(val.length, PROJECT_NAME_MAX_LEN, "Liian pitkä nimi")) {
            return
        }
        this.setSettings({ proj_name: prosConnect.filterSpecialChars(val) })
    }

    handleInput(val, paramName, checkPositiveNumber) {
        let change = {}
        change[paramName] = checkPositiveNumber ? this.validatePositiveInt(val): val
        this.setSettings(change)
    }

    showReason(ok, whyNot, checkOnly= false) {
        if (ok) {
            return true
        }
        if (!checkOnly) {
            prosNotificationShow(this, whyNot)
        }
    }

    validateUiFields(uiFields, checkOnly) {
        if (!uiFields.length) {
            if (!checkOnly) {
                prosNotificationShow(this, "VIRHE: asiakastiedot puuttuvat palvelimelta")
            }
            return false
        }
        for (let uiField of uiFields) {
            if (uiField.isMandatory &&
                !this.showReason(this.settings[uiField.key] &&
                    this.settings[uiField.key].length &&
                    this.settings[uiField.key] !== STR_NO_VALUE,
                "Anna " + uiField.finDesc, checkOnly)) {
                return false
            }
            if (uiField.key.indexOf('email') >= 0 && this.settings[uiField.key]) {
                return validateEmailsString(this.settings[uiField.key], uiField.isMandatory)
            }
        }
        return true
    }

    isProjectNameInUse() {
        return this.state.mainProjectList
            .find(mp => mp.name.toUpperCase() === this.settings.proj_name.toUpperCase())
    }

    isProjectNameValid(checkOnly) {
        return this.showReason(
            this.settings.proj_name && this.settings.proj_name.length >= PROJECT_NAME_MIN_LEN,
            "Anna projektille nimi - minimi pituus " + PROJECT_NAME_MIN_LEN, checkOnly)
            &&
            // check that name not already used
            this.showReason(!this.state.mainProjectList || !this.isProjectNameInUse(),
                "Projektin nimi on jo käytössä", checkOnly)
    }

    pageCompleted(phase, checkOnly= false) {
        switch(phase || this.state.phase) {
            case "phaseCreateProjectBilling":
                return this.isProjectNameValid(checkOnly)
            case "phaseCustomer":
                return this.showReason(this.settings.customerName &&
                        this.settings.customerName.length >= CUSTOMER_NAME_MIN_LEN,
                    "Anna yrityksen / asiakkaan nimi, minimipituus " + CUSTOMER_NAME_MIN_LEN, checkOnly) &&
                        this.validateUiFields(this.state.uiFieldsCustomerInfo, checkOnly)
            case "phaseBilling":
                return this.validateUiFields(this.state.uiFieldsBillingInfo, checkOnly)
            case "phaseCalculator":
                return true
            case "phaseSummary":
                return true
            case "phaseEditProjectBilling":
                return true
            default: return true
        }
    }

    clearCostEstimates(clearTestInfo) {
        this.settings.calc_opening_fee = ''
        this.settings.calc_monthly_fee = ''
        this.settings.calc_users_limit = ''

        this.settings.calc_extra_user_count = ''
        this.settings.calc_extra_user = ''
        this.settings.calc_extra_user_total = ''

        this.settings.calc_extra_viewer_count = ''
        this.settings.calc_extra_viewer = ''
        this.settings.calc_extra_viewer_total = ''

        this.settings.calc_monthly_total = ''
        this.settings.calc_bill_info = ''

        if (clearTestInfo) {
            this.settings.test_num_of_ains = ''
            this.settings.test_num_of_projects = ''
            this.settings.test_pricing_id = ''
        }
    }

    async nextPage() {
        if (!this.pageCompleted()) {
            return
        }
        let phaseInd = this.uiPhases().indexOf(this.state.phase) + 1
        let nextPhase = phaseInd < this.uiPhases().length ? phaseInd : this.uiPhases().length-1
        this.setState({phase: this.uiPhases()[nextPhase]})
    }

    prevPage() {
        let phaseInd = this.uiPhases().indexOf(this.state.phase) - 1
        let nextPhase = phaseInd >= 0 ? phaseInd : 0
        this.setState({phase: this.uiPhases()[nextPhase]})
    }

    firstPageNotCompleted(targetPage) {
        for (let i = 0; i < targetPage; i++) {
            if (!this.pageCompleted(this.uiPhases()[i], true)) {
                return i
            }
        }
        return 100
    }

    goToPage(phaseInd) {
        let currentPhaseInd = this.uiPhases().indexOf(this.state.phase)
        //let projectPage = this.uiPhases().indexOf('phaseProjectSettings')
        let calculatorPage = this.uiPhases().indexOf('phaseCalculator')
        if (phaseInd === calculatorPage) {
            this.clearCostEstimates(true)
        }
        let firstPageNotCompleted = this.firstPageNotCompleted(phaseInd)
        if (phaseInd === calculatorPage) {
            // From any page to cost calculation
            this.setState({phase: this.uiPhases()[phaseInd]})
            return
        }
        if (currentPhaseInd === calculatorPage) {
            // From calculator when have missing info in previous pages first such
            if (firstPageNotCompleted < phaseInd) {
                this.setState({phase: this.uiPhases()[firstPageNotCompleted]})
                return
            }
        }
        if (phaseInd > firstPageNotCompleted) {
            this.pageCompleted(this.uiPhases()[firstPageNotCompleted], false)
            this.setState({phase: this.uiPhases()[firstPageNotCompleted]})
            return
        }
        this.setState({phase: this.uiPhases()[phaseInd]})
    }

    isCustomeInfoPage() {
        return CREATE_PRJ_PHASES_CUSTOMER_EDIT.indexOf(this.state.phase) >= 0
    }

    renderSaveButtonText() {
        return (this.settings.customerGroup !== STR_NO_VALUE) ?
            "Tallenna" :
            "Tallenna keskeneräisenä"
    }

    renderNextPrevButtons() {
        let prevEnabled = this.uiPhases().indexOf(this.state.phase) > 0
        let nextEnabled = this.uiPhases().indexOf(this.state.phase) < this.uiPhases().length - 1
        if(!this.pageCompleted(this.state.phase, true)) nextEnabled = false
        let savingEnabled = this.mayEditCustomerData()
        if(!prevEnabled && !nextEnabled) savingEnabled = false
        const pageNum = this.uiPhases().indexOf(this.state.phase)
        const isOnlastPhase = pageNum === this.uiPhases().length - 1
        return <footer className={"page-footer"}>
            <div className={"btn-set_center"}>
                {pageNum > 0 ? <BasicButton
                        btnClass={"2nd"}
                        icon={"chevron-left"}
                        label={isOnlastPhase ? "Edellinen" : null}
                        action={() => {
                            this.prevPage()
                        }}
                        disabled={!prevEnabled}
                        title={"Edellinen"}
                    /> : null}
                {!isOnlastPhase ? <BasicButton
                        btnClass={"2nd"}
                        label={"Seuraava"}
                        icon={"chevron-right"}
                        action={() => {
                            this.nextPage()
                        }}
                        disabled={!nextEnabled}
                        title={"Seuraava"}
                        shrink={"lg"}
                    /> : null}
                {savingEnabled && this.state.phase !== 'phaseSummary' ? <BasicButton
                        btnClass={"primary"}
                        label={this.renderSaveButtonText()}
                        icon={"check"}
                        action={async ()=> {
                            await this.saveSettings()
                            await this.loadSettings(true)
                            if (this.props.refreshCustomerList) {
                                this.props.refreshCustomerList()
                            }
                        }}
                    /> : null}
            </div>
        </footer>
    }

    // renderSectionTitle(title, isValid, tag) {
    //     const CustomTag = (tag ? tag : 'label');//<label> by default
    //     const txt = title + ':';
    //     return <CustomTag>{txt}{(isValid ? '' : <span className="color-2nd">*</span>)}</CustomTag>
    // }

    isFieldValid(key, isMandatory) {
        if (!this.settings.hasOwnProperty(key)) {
            return !isMandatory
        }
        if (key.indexOf('email') >= 0) {
            return validateEmailsString(this.settings[key], isMandatory)
        }
        return true
    }

    renderEditPermissionNoteText() {
        return this.mayEditCustomerData() ? null: 'Vain asiakkaan pääkäyttäjät voivat muokata yhteys- ja laskutustietoja.'
    }

    renderCustomerInfo(uiFields, hideWhenNotAllowedToEdit) {
        if (!this.mayEditCustomerData() && hideWhenNotAllowedToEdit) {
            return null
        }
        return uiFields
            .sort((a, b) => a.sortOrder - b.sortOrder)
            .map(field => {
                let value = this.settings[field.key] !== STR_NO_VALUE ? this.settings[field.key] : ''
                const isValid= this.isFieldValid(field.key, field.isMandatory)
                return <React.Fragment key={field.key}>
                    <TextInput
                        isControlled={true}
                        label={field.finDesc}
                        value={value || ''}
                        placeholder={field.finPlaceholder || 'Kirjoita ' + field.finDesc.toLowerCase()}
                        required={field.isMandatory}
                        isValid={isValid}
                        disabled={!this.mayEditCustomerData()}
                        onChange={val => this.handleInput(val, field.key)}
                        type={field.key.indexOf('contact_email') > -1 ? "email" : null}
                    />
                </React.Fragment>
        })
    }

    setCurrentCustomerInfo(customerGroup, displayCategory, clearIfNewCustomer) {
        let customer = this.settings.serverCustomers ?
            this.settings.serverCustomers.find(custSettings => custSettings[ATTR_OBJ_ID] === customerGroup) : undefined
        let uiFields = this.getCustomerInfoFromTemplate(displayCategory)
        let changes = {}
        uiFields.forEach(uiField => {
            if (customer) {
                changes[uiField.key] = customer.hasOwnProperty(uiField.key) ?
                    (customer[uiField.key] !== STR_NO_VALUE) ? customer[uiField.key] : '' : ''
            } else {
                // not an existing customer or not found info
                if (clearIfNewCustomer) {
                    changes[uiField.key] = ''
                }
            }
        })
        this.setSettings(changes)
        return changes
    }

    isFieldLengthValid(name, minLength) {
        return (name && name.length >= minLength)
    }

    async saveSettings() {
        this.settings.updateCustomerData = this.settings.customerGroup !== STR_NO_VALUE
        let response = await prosConnect.saveCreateProjectSettings(this.settings)
        if (response.result === 'OK') {
            if (this.state.phase === 'phaseEditProjectBilling' && this.settings.mainProjectAttrs) {
                let mainProjectChanges = {}
                mainProjectChanges[ATTR_AWS_PROJECT_ID] = this.settings.mainProjectAttrs[ATTR_AWS_PROJECT_ID]
                mainProjectChanges[ATTR_OBJ_ID] = this.settings.mainProjectAttrs[ATTR_OBJ_ID]
                mainProjectChanges[ATTR_CUSTOMER_BILL_REFERENCE] = this.settings.projectBillingRef
                mainProjectChanges[ATTR_TEXT_TO_BILL] = this.settings[PROJECT_TEXT_TO_BILL]
                mainProjectChanges[ATTR_TEXT] = this.settings.proj_name
                await prosConnect.updateItemsAttributes(mainProjectChanges)
            }
        }
        if (this.props.isEditCustomerMode) {
            await this.saveMiscCustomerSettings()
        }
        prosNotificationShow(this,  response.result === 'OK' ? "Tallennettu" : "Virhe server yhteydessä")
    }

    renderCustomerId() {
        if ( ! prosConnect.isSuperUserModeInUse()) {
            return null
        }
        return <TextInput
            label={'Asiakastunnus'}
            isControlled={true}
            value={this.settings.customerGroup && this.settings.customerGroup !== STR_NO_VALUE ? this.settings.customerGroup : ''}
            placeholder={"Vain superoikeuksilla"}
            onChange={val => this.handleSettingsChange(val, 'customerGroup')}
            disabled={!prosConnect.isSuperUserModeInUse()}
        />
    }

    renderSelectCustomer() {
        if (!this.props.isMakingNewProject) {
            // Editing project
            return <>
                {this.renderCustomerId()}
            </>
        }
        // Adding new project - let user to choose customer
        let newCustomer = this.settings.customerGroup && this.settings.customerGroup === STR_NO_VALUE

        const customerList = [{
            value: STR_NO_VALUE,
            text: '+ Uusi asiakas',
        }]
        this.settings.serverCustomers.forEach((customer) => {
            customerList.push({
                value: customer[ATTR_OBJ_ID],
                text: customer[ATTR_OBJ_ID] + ': ' + customer.text
            })
        })

        return <div className={"sub-container"}>
            <h3>Valitse asiakas</h3>
            <DropdownMenu
                className={"width-100"}
                values={customerList}
                currentValue={newCustomer ? STR_NO_VALUE : this.settings.customerGroup}
                onSelect={(val)=> {
                    this.selectCustomer(val, true)
                }}
            />
            <Spacer/>
            {this.renderCustomerId()}
        </div>
    }

    renderPromptCustomerInfo() {
        return <>
                {this.renderSelectCustomer()}
                <div className={"sub-container"}>
                    <TextInput
                        isControlled={true}
                        label={"Yrityksen / asiakkaan nimi"}
                        value={this.settings.customerName}
                        required
                        isValid={this.isFieldLengthValid(this.settings.customerName, CUSTOMER_NAME_MIN_LEN)}
                        onChange={val => this.handleInput(val, 'customerName')}
                        disabled={!this.mayEditCustomerData()}
                        placeholder={"Kirjoita nimi"}
                        autoFocus
                        info={this.renderEditPermissionNoteText()}
                    />
                    {this.renderCustomerInfo(this.state.uiFieldsCustomerInfo, true)}
                </div>
        </>
    }

    async calculateCost() {
        this.clearCostEstimates(false)
        if (this.settings.estimate_num_of_users === '') {
            this.setSettings({estimate_num_of_users: 1})
        }
        this.setCampaignCode()
        let response = await prosConnect.customerRequestCost(this.settings)
        if (response && response.result && response.result === 'OK') {
            if (response.settings && response.settings.settingsVersion === SETTINGS_DATA_VERSION) {
                this.setSettings(response.settings)
                prosNotificationShow(this, 'Laskettu')
                return
            }
        }
        prosNotificationShow(this, 'Virhe server yhteydessä')
    }

    validatePositiveInt(value) {
        if (value === '') {
            return value
        }
        return value < 0 ? 0 : value
    }

    renderPromptBillingInfo() {
        return <>
                <div className={"sub-container"}>
                    {this.renderCustomerInfo(this.state.uiFieldsBillingInfo, false)}
                    {this.renderEditPermissionNoteText()}
                </div>
        </>
    }

    setCampaignCode() {
        this.settings.campaign_code = this.state.mainProjectCampaignCodeIsValid ?
            this.state.mainProjectCampaignCode : STR_NO_VALUE
    }

    async placeAnOrder() {
        this.setCampaignCode()
        let response = await prosConnect.customerOrderProject(this.settings)
        if (response && response.result) {
            if (response.result === 'OK') {
                prosConnect.awaitGetProjects(true)
                BasicModal('Projekti tilattu!', 'Projektin pääkäyttäjät voivat nyt tehdä osaprojekteja.', {
                    action: ()=> {
                        this.props.switchToReportView(500)
                    },
                    btnText: 'Jatka',
                    hideDismissButton: true
                })
                return true
            } else {
                let errMsg = response.errorCauseFin ? response.errorCauseFin : 'Palvelin hylkäsi tilauksen'
                prosLogErr(response)
                prosNotificationShow(this, errMsg, true, true)
                return false
            }
        } else {
            prosNotificationShow(this, 'Virhe server yhteydessä')
            return false
        }
    }

    getProjectName(pid) {
        for (let mainProj of this.state.customerProjectsForPermissions) {
            for (let subProj of mainProj.projects) {
                if (subProj[ATTR_AWS_PROJECT_ID] === pid) {
                    return subProj[ATTR_MAIN_PROJECT_NAME] + ' / ' + subProj[ATTR_TEXT]
                }
            }
        }
    }

    renderPromptCount(title, attr) {
        return <TextInput
            type={"number"}
            label={title}
            placeholder={"Kirjoita numero"}
            value={this.validatePositiveInt(this.settings[attr] ? this.settings[attr] : '')}
            onChange={val => this.handleInput(val, attr, false)}
        />
    }

    renderPromptCode(title, attr) {
        return <TextInput
            label={title}
            placeholder={"Kirjoita ID"}
            value={this.settings[attr]}
            onChange={val => this.handleInput(val, attr, false)}
        />
    }

    renderPromptExtraParams() {
        if (!prosConnect.isSuperUserModeInUse()) {
            return null
        }
        return <>
            <Spacer/>
            <h3>Hintalaskurin testiparametrit</h3>
            <p>Kun "super user" toiminto on valittuna voit testata hintalaskuria antamalla käsin lisää laskuparametreja</p>
            <div className={"element-set"}>
                {this.renderPromptCount('A-ins käyttäjien määrä', 'test_num_of_ains')}
                {this.renderPromptCount('Projektien lukumäärä', 'test_num_of_projects')}
                {this.renderPromptCode('PricingId', 'test_pricing_id')}
            </div>
        </>
    }

    renderCostCalc(field, label, isPrice = false, defaultValue = '', after_text ='') {
        // toFixed(2)
        let value = this.settings.hasOwnProperty(field) && this.settings[field] !== STR_NO_VALUE ?
            this.settings[field] : defaultValue
        let isANumber = value !== '' && isPrice && /^[0-9,.]*$/.test(value)
        let showValue = isANumber ? parseFloat(value).toFixed(2) : value
        return showValue ? <p> <b> {label} </b> {showValue} {after_text}</p> : null
    }


    getCostCalc(field, isPrice = false) {
        let value = (this.settings.hasOwnProperty(field) && this.settings[field] !== STR_NO_VALUE ? this.settings[field] : 0.00);
        let isANumber = value !== '' && isPrice && /^[0-9,.]*$/.test(value);
        let showValue = isANumber ? parseFloat(value).toFixed(2) : value;
        return (isPrice ? <>{showValue}&euro;</> : showValue);
    }

    renderExtraUserFee() {
        if (!this.settings.calc_has_extra_user_fee) return null
        return <>
            <div>
                <div>Lisäkäyttäjät, muokkausoikeudet</div>
                <div>{this.getCostCalc('calc_extra_user_count', false)}</div>
                <div>{this.getCostCalc('calc_extra_user', true)}/kk</div>
                <div>{this.getCostCalc('calc_extra_user_total', true)}</div>
            </div>
            <div>
                <div>Lisäkäyttäjät, katseluoikeudet</div>
                <div>{this.getCostCalc('calc_extra_viewer_count', false)}</div>
                <div>{this.getCostCalc('calc_extra_viewer', true)}/kk</div>
                <div>{this.getCostCalc('calc_extra_viewer_total', true)}</div>
            </div>
        </>
    }

    renderCostCalculatorTable() {
        return <div className={"sub-container"}>
            <section className="prices">
                <h2>Kertamaksu</h2>
                <div>
                    <div>Avausmaksu</div>
                    <div>&nbsp;</div>
                    <div>&nbsp;</div>
                    <div className={"col-6"}>{this.getCostCalc('calc_opening_fee',true)}</div>
                </div>
                <h2>Kuukausimaksut</h2>
                <header>
                    <div>&nbsp;</div>
                    <div>Määrä</div>
                    <div>à-hinta</div>
                    <div>Yhteensä</div>
                </header>
                <div>
                    <div>Käyttömaksu, {this.getCostCalc('calc_users_limit', false, '')} henkilöä</div>
                    <div>1</div>
                    <div>{this.getCostCalc('calc_monthly_fee', true)}/kk</div>
                    <div>{this.getCostCalc('calc_monthly_fee', true)}</div>
                </div>
                {this.renderExtraUserFee()}
                <footer>
                    <div>&nbsp;</div>
                    <div>
                        <h2>Yhteensä</h2>
                        <div>
                            <div>Kertamaksu</div>
                            <div>{this.getCostCalc('calc_opening_fee', true)}</div>
                        </div>
                        <div>
                            <div>Kuukausimaksu</div>
                            <div>{this.getCostCalc('calc_monthly_total', true)}</div>
                        </div>
                        <p className={"txt-sm"}>Arvioidut hinnat ovat arvolisäverottomia.<br/>Hintoihin lisätään arvonlisävero.</p>
                    </div>
                </footer>
            </section>
        </div>
    }


    renderCalculatorInfoBox(){
        if(!this.settings.calc_users_limit) return null
        const info_box = this.settings.calc_user_steps.map(i =>{
            let thisPricingStep = this.settings.calc_users_limit === i
            return <span key={i} className={thisPricingStep ? "selected": ""}>{i}</span>
        })
        return <div className={"sub-container tier-info"}>
            <div>
                <div className={"box box-tier-info"}>{info_box}</div>
                <div className={"box box-custom"}><i className={"ui-icon ui-icon-user ui-icon_color-main"} /><p>Valittu porras sisältää muokkausoikeudet {this.settings.calc_users_limit} käyttäjälle.</p></div>
            </div>
            <div className={"box box-info"}>{this.renderCostCalc('calc_bill_info', '', false)}</div>
        </div>
    }

    async doesServerAcceptCampaignCode(code) {
        let response = await validateCampaignCode(code)
        if (response.result === 'OK') {
            return ''
        }
        if (response.errorCause === 'campaignNotFound') {
            return 'Koodia ei löydy'
        }
        if (response.errorCause === 'campaignExpired') {
            return 'Kampanja on päättynyt'
        }
        return response.errorCause
    }

    async validateCampaignCode(val) {
        let isCodeOk = false
        let isCodeLongEnough = val?.length > 2
        let campaignErrorText
        if (isCodeLongEnough) {
            campaignErrorText = await this.doesServerAcceptCampaignCode(val)
            if (campaignErrorText === '') {
                isCodeOk = true
            }
        } else {
            campaignErrorText = "Koodi on liian lyhyt"
        }
        this.setState({
            mainProjectCampaignCode: val,
            mainProjectCampaignCodeIsValid: isCodeOk,
            mainProjectCampaignCodeError: campaignErrorText
        })
    }

    renderCampaignCodeError(){
        if(!this.state.mainProjectCampaignCode || this.state.mainProjectCampaignCodeIsValid) {
            // No code or code is valid
            return null
        }
        if(this.state.mainProjectCampaignCodeError){
            return <>
                <Spacer />
                <div className={"msg msg-error"}>
                    <h3>Kampanjakoodi virheellinen</h3>
                    <p>{this.state.mainProjectCampaignCodeError}</p>
                </div>
            </>
        }
        return <>
            <Spacer />
            <div className={"msg"}>
                <p>Kirjoita koodi ja hyväksytä se</p>
            </div>
        </>
    }

    resetCampaignCode(){
        this.setState({
            mainProjectCampaignCodeError: '',
            mainProjectCampaignCode: undefined,
            mainProjectCampaignCodeIsValid: false
        })
    }

    renderCampaignCode() {
        if(!this.props.isMakingNewProject) return null
        return <div className={"campaign-code" + (this.state.mainProjectCampaignCodeIsValid ? "-ok" : "")}>
            <AccordionDropdown
                    closeable={!this.state.mainProjectCampaignCodeIsValid}
                    header={<h3 className={"element-set valign-center"}>
                        <i className={"ui-icon ui-icon-outline-"
                            + (this.state.mainProjectCampaignCodeIsValid ? "check ui-icon_color-light" : "info")}/>
                        Kampanjakoodi
                        {this.state.mainProjectCampaignCodeIsValid ?
                            ": " + this.state.mainProjectCampaignCode + " - vahvistettu!"
                            : ""}</h3>}
                    callback={()=>this.resetCampaignCode()}
                >
                {!this.state.mainProjectCampaignCodeIsValid ?
                    <TextInput
                        placeholder={"Kirjoita koodi"}
                        value={this.state.mainProjectCampaignCode}
                        onChange={(val)=> {
                            this.setState({mainProjectCampaignCode: val})
                        }}
                        onSubmit={(val)=> {
                            this.validateCampaignCode(val)
                        }}
                        className={"margin-0"}
                    />
                    : null}
                {this.renderCampaignCodeError()}
            </AccordionDropdown>
        </div>
    }

    renderCalculator() {
        return <>
            <div className={"sub-container price-calculator"}>
                <div>
                    <h2>Arvioitu käyttäjien lukumäärä</h2>
                    <p>Syötä alle arvioidut käyttäjämäärät. Laskuri laskee aina edullisimman vaihtoehdon automaattisesti.</p>
                    <div className={"element-set"}>
                        {this.renderPromptCount('Muokkausoikeudet', 'estimate_num_of_users')}
                        {this.renderPromptCount('Katseluoikeudet', 'estimate_num_of_readers')}
                    </div>
                    {this.renderPromptExtraParams()}
                    <Spacer size={"lg"}/>
                    <div className={"element-set flex-center"}>
                        <BasicButton
                            btnClass={"primary"}
                            label={"Laske hinta-arvio"}
                            action={() => this.calculateCost()}
                        />
                        {this.settings.calc_users_limit === '' ? <>
                                <span className={"padding"}>tai</span>
                                <BasicButton
                                    btnClass={"2nd"}
                                    icon={"arrow-right"}
                                    iconPosition={"right"}
                                    label={"Ohita"}
                                    action={() => {
                                        this.nextPage()
                                    }}
                                />
                            </> : null}
                    </div>
                    {this.settings.calc_users_limit !== '' ? this.renderCostCalculatorTable() : null}
                </div>
            </div>
        </>
    }

    renderSummary() {
        let customerId = this.settings.customerGroup !== STR_NO_VALUE ?
            this.settings.customerGroup: 'uusi - luodaan tilattaessa'
        let adminEmailCount = this.settings.admin_emails ? this.settings.admin_emails.split(',').length : 1;
        return <>
            <h2>Tarkista tilauksen tiedot</h2>
            <div className={"price-calculator"}>
                <div className={"sub-container order-summary"}>
                    <div>
                        <div>Projektin nimi:</div>
                        <div>{this.settings.proj_name}</div>
                    </div>
                    <div>
                        <div>Pääkäyttäjiä:</div>
                        <div>{adminEmailCount}</div>
                    </div>
                    <div>
                        <div>Asiakastunnus:</div>
                        <div>{customerId}</div>
                    </div>
                    <div>
                        <div>Yrityksen / asiakkaan nimi:</div>
                        <div>{this.settings.customerName}</div>
                    </div>
                </div>
            </div>
            {this.renderOrderCompletion()}
        </>
    }

    renderOrderCompletion(){
        if(this.state.orderCompleted){
            return <h2>Valmis</h2>
        }
        return <>
            <h2>Tilauksen hyväksyntä</h2>
            <ConfirmButton
                label={"Tilaa projekti"}
                action={() => {
                    this.setState({orderOngoing: true})
                    this.placeAnOrder().then(r => {
                        if (r) {
                            this.setState({orderOngoing: false, orderCompleted: true})
                        } else {
                            this.setState({orderOngoing: false})
                        }
                    })
                }}
            />
        </>
    }

    isOrderingDisabled() {
        return this.state.orderOngoing || this.state.orderCompleted ||
            (this.state.mainProjectCampaignCode && !this.state.mainProjectCampaignCodeIsValid)
    }

    isProjectNameValidForTextInput(){
        let isProjectNameValid = !this.props.isMakingNewProject ||
            (!this.isProjectNameInUse() && this.isFieldLengthValid(this.settings.proj_name, PROJECT_NAME_MIN_LEN) && this.settings.proj_name.length <= PROJECT_NAME_MAX_LEN)
        return isProjectNameValid
    }

    renderEditProjectBillingAttrs(enableProjectNameEditing) {
        let noteText = this.mayEditCustomerData() ?
            null : 'Vain asiakkaan pääkäyttäjät voivat muokata projektin laskutustietoja'
        let billRef = prosConnect.getValidAttr(this.settings, 'projectBillingRef') || ''
        let billComment = prosConnect.getValidAttr(this.settings, PROJECT_TEXT_TO_BILL) || ''
        let projectName = this.settings.proj_name && this.settings.proj_name !== STR_NO_VALUE ? this.settings.proj_name : ''

        return <>
            <div className="sub-container">
                <TextInput
                    label={'Projektin nimi'}
                    value={projectName}
                    onChange={val => this.handleProjectName(val)}
                    disabled={!enableProjectNameEditing}
                    placeholder={"Kirjoita projektin nimi"}
                    isControlled={true}
                    required
                    isValid={this.isProjectNameValidForTextInput()}
                />
            </div>
            <div className="sub-container">
                <TextInput
                    label={'Viite laskuun'}
                    value={billRef}
                    disabled={!this.mayEditCustomerData() && !enableProjectNameEditing}
                    onChange={val => this.handleSettingsChange(val, 'projectBillingRef')}
                    placeholder={"Kirjoita viite"}
                />
            </div>
            <div className="sub-container">
                <TextInput
                    label={'Projektikohtainen saateteksti laskuun'}
                    value={billComment}
                    disabled={!this.mayEditCustomerData() && !enableProjectNameEditing}
                    onChange={val => this.handleSettingsChange(val, PROJECT_TEXT_TO_BILL)}
                    placeholder={"Kirjoita saateteksti"}
                    info={noteText}
                />
            </div>
        </>
    }

    renderEditProjectBilling(enableProjectNameEditing) {
        if (!this.settings.mainProjectAttrs && !enableProjectNameEditing) {
            return <div>
                    <p><br></br> Projektin tietojen haku epäonnistui !</p>
            </div>
        }
        return <>
                {this.renderEditProjectBillingAttrs(enableProjectNameEditing)}
        </>
    }

    renderProjectPhaseTabs() {
        let linkValues = this.uiPhases().map((phase, i) => {
            let missingInfoInTab = this.pageCompleted(phase, true) ? false : true
            return {
                value: i,
                text: CREATE_PRJ_PHASE_FOR_UI[phase],
                selected: this.state.phase === phase,
                required: missingInfoInTab
            }
        })
        let phaseAsNumber = linkValues.findIndex((it, i) => linkValues[i].selected)
        return <TabsNavigation values={linkValues} callback={val => this.goToPage(val)} currentTab={phaseAsNumber} className={"padding-top"} />
    }

    renderWindowTitle() {
        if (this.props.isEditCustomerMode) {
            return null
        }
        let title = this.props.isMakingNewProject ?
            "Uuden projektin tilaaminen":
            "Asiakas- ja laskutustietojen muokkaaminen"
        return <header className="page-header">
            <h1>{title}</h1>
            <BasicButton
                btnClass={"primary"}
                label={"Poistu"}
                icon={"arrow-left"}
                action={this.props.switchToReportView}
            />
        </header>

    }

    async saveLogoToServer(logoFile) {
        prosNotificationShow(this, "Tallennetaan..", false, false, true)
        prosLogDt('Saving new logo file', logoFile)
        let fileNameInAws = await prosConnect.startFileUpload(logoFile, false, prosConnect.S3_THUMP_FOLDER)
        prosLogDt('Project logo saved', fileNameInAws)
        prosNotificationShow(this, "Tallennettu")
        this.setState({logoFileName: fileNameInAws})
        prosPopupClose()
    }

    renderLogoUploader() {
        return <FileUploader
            fileslimit={1}
            formats={['.jpg', '.jpeg', '.png']}
            callback={(file)=> this.saveLogoToServer(file[0])}
        />
    }

    changeLogoSettings() {
        prosPopupClose()
        this.openChangeLogoPopup()
    }

    openChangeLogoPopup() {
        prosPopupOpenDynamic(this,
            'Lataa uusi logo',
            () => this.renderLogoUploader(),
        )
    }

    deleteLogo() {
        this.setState({logoFileName: STR_NO_VALUE})
    }

    renderChangeLogoButton() {
        return  <>
            <div className={"element-set-v"}>
                <BasicButton
                    label={"Vaihda logo"}
                    btnClass={"2nd"}
                    icon={"image"}
                    action={() => { this.changeLogoSettings()}}
                />
                <BasicButton
                    label={"Poista logo"}
                    icon={"delete"}
                    action={() => {
                        this.deleteLogo()
                    }}
                />
            </div>
        </>
    }

    renderCustomerLogo() {
        if (this.state.logoFileName && this.state.logoFileName !== STR_NO_VALUE) {
            let imagePath = prosConnect.getLogoThumpPath(this.state.logoFileName)
            return <div className={"element-set valign-top"}>
                <UiImage
                    imageSrc={imagePath}
                    alt={'logo'}
                    className={"flex-grow"}
                />
                {this.renderChangeLogoButton()}
            </div>
        } else {
            return this.renderLogoUploader()
        }
    }

    renderCustomerOther() {
        return <div>
            <h2>Logo</h2>
            <p>Raporteissa käytettävä Logo kun projektille ei ole määritetty</p>
            {this.renderCustomerLogo()}
        </div>
    }

    renderPage() {
        switch (this.state.phase) {
            case 'phaseCustomer': return this.renderPromptCustomerInfo()
            case 'phaseCalculator': return this.renderCalculator()
            case 'phaseBilling': return this.renderPromptBillingInfo()
            case 'phaseCreateProjectBilling': return this.renderEditProjectBilling(true)
            case 'phaseEditProjectBilling': return this.renderEditProjectBilling(true)
            case 'phaseSummary': return this.renderSummary()
            case 'phaseCustomerOther': return this.renderCustomerOther()
            default: return <h2>{"no render for phase" + this.state.phase}</h2>
        }
    }

    render() {
        if (this.state.isLoading) {
            return <LoadingAnimation size={"lg"} />
        }
        if (!this.state.hasSettingsFromServer) {
            return <>
                <h1> Virhe server yhteydessä </h1>
                {this.renderBackToProject()}
                </>
        }
        require("./assets/scss/CreateProject.scss");
        return (
            <>
                {this.renderWindowTitle()}
                {this.renderProjectPhaseTabs()}
                <section className={"create-project create-main-project grid-container grid-1 grid-2_lg"}>
                    <div className={"sub-container"}>
                        {this.renderPage()}
                    </div>
                    <div className={"sub-container"}>
                        {this.state.phase === 'phaseCalculator' ? this.renderCalculatorInfoBox() : null}
                        {this.renderCampaignCode()}
                    </div>
                </section>
                {this.renderNextPrevButtons()}
                {prosPopupRender(this, "CreateMainProject")}
            </>
        )
    }
}
